import { useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/core';
import { useOverlayScrollbars } from 'overlayscrollbars-react';
import 'overlayscrollbars/styles/overlayscrollbars.css';
import '../../../../styles/kadarOverlayScrollbars.css';
import { domRefPropType } from '../propTypes';

const useStyles = makeStyles(() => ({
  overlayWrapper: {
    boxSizing: 'border-box',
    width: '100%',
    height: '100%',
  },
  verticalSlot: {
    position: 'absolute',
    right: 0,
    height: '100%',
  },
  horizontaSlot: {
    position: 'absolute',
    bottom: 0,
    width: '100%',
  },
}));

const OverlayScrollbarsHost = ({
  children,
  rootRef,
  viewportRef,
  vScrollbarSlotRef,
  hScrollbarSlotRef,
  overlayWrapperClass = undefined,
  verticalScrollClass = undefined,
  horizontalScrollClass = undefined,
}) => {
  const classes = useStyles();

  const [initialize] = useOverlayScrollbars({
    options: {
      overflow: {
        x: 'hidden',
        y: 'scroll',
      },
      scrollbars: {
        theme: 'os-theme-kadar',
        dragScroll: true,
      },
    },
    events: {
      initialized: osInstance => {
        const { scrollbarHorizontal, scrollbarVertical } =
          osInstance.elements();

        if (vScrollbarSlotRef.current && scrollbarVertical) {
          vScrollbarSlotRef.current.append(scrollbarVertical.scrollbar);
        }
        if (hScrollbarSlotRef.current && scrollbarHorizontal) {
          hScrollbarSlotRef.current.append(scrollbarHorizontal.scrollbar);
        }
      },
    },
  });

  useEffect(() => {
    const { current: root } = rootRef;
    const { current: viewport } = viewportRef;

    if (root && viewport) {
      initialize({
        target: root,
        elements: {
          viewport,
        },
      });
    }
  }, [initialize, rootRef, viewportRef]);

  return (
    <>
      <div
        data-overlayscrollbars-initialize=""
        ref={rootRef}
        className={classNames(classes.overlayWrapper, overlayWrapperClass)}
      >
        {children}
      </div>
      <div
        ref={vScrollbarSlotRef}
        className={classNames(classes.verticalSlot, verticalScrollClass)}
      />
      <div
        ref={hScrollbarSlotRef}
        className={classNames(classes.horizontaSlot, horizontalScrollClass)}
      />
    </>
  );
};

OverlayScrollbarsHost.propTypes = {
  children: PropTypes.node.isRequired,
  rootRef: domRefPropType.isRequired,
  viewportRef: domRefPropType.isRequired,
  vScrollbarSlotRef: domRefPropType.isRequired,
  hScrollbarSlotRef: domRefPropType.isRequired,
  overlayWrapperClass: PropTypes.string,
  verticalScrollClass: PropTypes.string,
  horizontalScrollClass: PropTypes.string,
};

export default OverlayScrollbarsHost;
